// extracted by mini-css-extract-plugin
export default {"txtInput":"Input_txtInput__xV6a2","errorMessage":"Input_errorMessage__5ucMv","errorBorder":"Input_errorBorder__9RJQs"};